// import React, { useEffect, useState } from "react";
// import SideNavBar from "../SideNavBar";
// import ChatContextProvider from "../../contexts/ChatContext";
// import Contacts from "../ChatBox/Contacts/Contacts";
// import Main from "../ChatBox/Main/Main";
// import { Box, Paper, Typography, Breadcrumbs, Link } from "@mui/material";
// import { QueryClientProvider, QueryClient } from "react-query";
// import CallModal from "../ChatBox/options/CallModal";
// import VideoChat from "../ChatBox/Calling/VideoChat";
// import { useSelector } from "react-redux";
// import { useHistory } from "react-router-dom";
// import AutoFixHigh from "@mui/icons-material/AutoFixHigh";
// import NavigateNextIcon from "@mui/icons-material/NavigateNext";

// const queryClient = new QueryClient();

// const ChatBoxPage = () => {
//   const { showChats, showContacts } = useSelector((state) => state.manageChat);
//    const history = useHistory(); 

//    const handleBreadcrumbClick = (event, path) => {
//     event.preventDefault();
//     history.push(path);
//   };

//   return (
//     <SideNavBar>
//       <ChatContextProvider>
//         <QueryClientProvider client={queryClient}>
//           <Box sx={{ mb: 1,}}>
//             <Paper
//               elevation={1}
//               sx={{
//                 pt: 1,
//                 bgcolor: "#838aa9",
//                 borderRadius: 3,
//                 border: "1px solid",
//                 borderColor: "divider",
//                 transition: "all 0.3s ease",
//                 "&:hover": {
//                   boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
//                 },
//               }}
//             >
//               <Breadcrumbs
//                 separator={
//                   <NavigateNextIcon fontSize="small" sx={{ color: "#667eea" }} />
//                 }
//                 aria-label="breadcrumb"
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   flexWrap: "nowrap",
//                 }}
//               >
//                 <Box
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     flexWrap: "nowrap",
//                     gap: 1,
//                   }}
//                 >
//                   <Link
//                     to="/myteam"
//                     onClick={(e) => handleBreadcrumbClick(e, "/myteam")}
//                     style={{
//                       textDecoration: "none",
//                       color: "#667eea",
//                       fontWeight: 500,
//                       fontSize: "0.95rem",
//                       padding: "4px 12px",
//                       borderRadius: "6px",
//                       transition: "all 0.2s ease",
//                       whiteSpace: "nowrap",
//                       display: "flex",
//                       alignItems: "center",
                    
//                     }}
//                     onMouseEnter={(e) => {
//                       e.currentTarget.style.backgroundColor =
//                         "rgba(102, 126, 234, 0.08)";
//                       e.currentTarget.style.color = "#764ba2";
//                     }}
//                     onMouseLeave={(e) => {
//                       e.currentTarget.style.backgroundColor = "transparent";
//                       e.currentTarget.style.color = "#667eea";
//                     }}
//                   >
//                     <AutoFixHigh sx={{ fontSize: 10, color: "#667eea" }} />
//                     Teams
//                   </Link>
//                   <NavigateNextIcon
//                     fontSize="small"
//                     sx={{ color: "#667eea", mx: 0.5 }}
//                   />
//                   <Typography
//                     sx={{
//                       color: "#1a1a1a",
//                       fontWeight: 600,
//                       fontSize: "0.95rem",
//                       padding: "4px 12px",
//                       borderRadius: "6px",
//                       backgroundColor: "rgba(102, 126, 234, 0.08)",
//                       whiteSpace: "nowrap",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 0.5,
//                     }}
//                   >
//                     <AutoFixHigh sx={{ fontSize: 20, color: "#667eea" }} />
//                     Chat
//                   </Typography>
//                 </Box>
//               </Breadcrumbs>
//             </Paper>
//           </Box>

//           <Box 
//             sx={{
//               display: 'flex',
//               height: 'calc(100vh - 64px)',
//               width: '100%',
//               overflow: 'hidden',
//               bgcolor: '#d9dae2'
//             }}
//           >
//             <CallModal />
//             <VideoChat />
            
//             <Box 
//               sx={{
//                 minWidth: '370px',
//                 maxWidth: '370px',
//                 height: '100%',
//                 minHeight: '89vh',
//                 maxHeight: '89vh',
//                 bgcolor: 'white',
//                 borderRight: '1px solid #d9dae2',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 overflow: 'hidden',
//                 position: 'relative'
//               }}
//             >
//               <Contacts />
//             </Box>

//             <Box 
//               sx={{
//                 flex: 1,
//                 // height: '100%',
//                 marginTop:"14px",
//                 marginRight:"10px",
//                 minHeight: '88vh',
//                 maxHeight: '88vh',
//                 bgcolor: '#d9dae2',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 overflow: 'hidden',
//                 borderRadius:"5px"
//               }}
//             >
//               <Main />
//             </Box>
//           </Box>
//         </QueryClientProvider>
//       </ChatContextProvider>
//     </SideNavBar>
//   );
// };

// export default ChatBoxPage;


import React, { useEffect, useState } from "react";
import SideNavBar from "../SideNavBar";
import ChatContextProvider from "../../contexts/ChatContext";
import Contacts from "../ChatBox/Contacts/Contacts";
import Main from "../ChatBox/Main/Main";
import { Box, Paper, Typography, Breadcrumbs, Link } from "@mui/material";
import { QueryClientProvider, QueryClient } from "react-query";
import CallModal from "../ChatBox/options/CallModal";
import VideoChat from "../ChatBox/Calling/VideoChat";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import AutoFixHigh from "@mui/icons-material/AutoFixHigh";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ChatFeatureBot from "../../bot/chatFeatureBot"; // ← Import the bot
import {
  BOT_TYPES,
  getBotGuideSettings,
  recordBotGuideAutoOpen,
} from "../settingsNew";

const queryClient = new QueryClient();

const ChatBoxPage = () => {
  const { showChats, showContacts } = useSelector((state) => state.manageChat);
  const history = useHistory();

  // ✅ Bot visibility state
  const [chatBotEnabled, setChatBotEnabled] = useState(true);
  const [chatBotAutoStart, setChatBotAutoStart] = useState(false);

  // ✅ Read bot access from localStorage
  useEffect(() => {
    const syncChatBotState = () => {
      const currentUserEmail = sessionStorage.getItem("currentUserEmail");

      if (currentUserEmail) {
        const savedPrefs = localStorage.getItem(`botAccess_${currentUserEmail}`);

        if (savedPrefs) {
          const parsed = JSON.parse(savedPrefs);
          setChatBotEnabled(parsed.chat !== false);
        }
      }

      const guideSettings = getBotGuideSettings(BOT_TYPES.CHAT);
      setChatBotAutoStart(guideSettings.shouldAutoOpen);
    };

    syncChatBotState();

    const handleBotAccessChange = (event) => {
      if (event?.detail?.botType === BOT_TYPES.CHAT) {
        syncChatBotState();
      }
    };

    window.addEventListener("botAccessChanged", handleBotAccessChange);

    return () => {
      window.removeEventListener("botAccessChanged", handleBotAccessChange);
    };
  }, []);


  const handleBreadcrumbClick = (event, path) => {
    event.preventDefault();
    history.push(path);
  };

  return (
    <SideNavBar>
      <ChatContextProvider>
        <QueryClientProvider client={queryClient}>

          {/* ── TOUR TARGET: breadcrumb navigation ── */}
          <Box id="chat-tour-breadcrumb" sx={{ mb: 1 }}>
            <Paper
              elevation={1}
              sx={{
                pt: 1,
                bgcolor: "#838aa9",
                borderRadius: 3,
                border: "1px solid",
                borderColor: "divider",
                transition: "all 0.3s ease",
                "&:hover": {
                  boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
                },
              }}
            >
              <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" sx={{ color: "#667eea" }} />}
                aria-label="breadcrumb"
                sx={{ display: "flex", alignItems: "center", flexWrap: "nowrap" }}
              >
                <Box sx={{ display: "flex", alignItems: "center", flexWrap: "nowrap", gap: 1 }}>
                  <Link
                    to="/myteam"
                    onClick={(e) => handleBreadcrumbClick(e, "/myteam")}
                    style={{
                      textDecoration: "none",
                      color: "#667eea",
                      fontWeight: 500,
                      fontSize: "0.95rem",
                      padding: "4px 12px",
                      borderRadius: "6px",
                      transition: "all 0.2s ease",
                      whiteSpace: "nowrap",
                      display: "flex",
                      alignItems: "center",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "rgba(102, 126, 234, 0.08)";
                      e.currentTarget.style.color = "#764ba2";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "transparent";
                      e.currentTarget.style.color = "#667eea";
                    }}
                  >
                    <AutoFixHigh sx={{ fontSize: 10, color: "#667eea" }} />
                    Teams
                  </Link>
                  <NavigateNextIcon fontSize="small" sx={{ color: "#667eea", mx: 0.5 }} />
                  <Typography
                    sx={{
                      color: "#1a1a1a",
                      fontWeight: 600,
                      fontSize: "0.95rem",
                      padding: "4px 12px",
                      borderRadius: "6px",
                      backgroundColor: "rgba(102, 126, 234, 0.08)",
                      whiteSpace: "nowrap",
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                    }}
                  >
                    <AutoFixHigh sx={{ fontSize: 20, color: "#667eea" }} />
                    Chat
                  </Typography>
                </Box>
              </Breadcrumbs>
            </Paper>
          </Box>

          {/* ── Main Chat Layout ── */}
          <Box
            sx={{
              display: "flex",
              height: "calc(100vh - 64px)",
              width: "100%",
              overflow: "hidden",
              bgcolor: "#d9dae2",
            }}
          >
            <CallModal />
            <VideoChat />

            {/* ── TOUR TARGET: contacts sidebar panel ── */}
            <Box
              id="chat-tour-contacts-panel"
              sx={{
                minWidth: "370px",
                maxWidth: "370px",
                height: "100%",
                minHeight: "89vh",
                maxHeight: "89vh",
                bgcolor: "white",
                borderRight: "1px solid #d9dae2",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                position: "relative",
              }}
            >
              {/*
                Pass tourIds as props to Contacts so it can apply them
                to its internal elements (search, new-chat btn, create-group btn, contact-item)
              */}
              <Contacts tourIds={{
                search: "chat-tour-contacts-search",
                newChat: "chat-tour-new-chat",
                createGroup: "chat-tour-create-group",
                contactItem: "chat-tour-contact-item",
              }} />
            </Box>

            {/* ── TOUR TARGET: main chat area ── */}
            <Box
              id="chat-tour-chat-area"
              sx={{
                flex: 1,
                marginTop: "14px",
                marginRight: "10px",
                minHeight: "88vh",
                maxHeight: "88vh",
                bgcolor: "#d9dae2",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                borderRadius: "5px",
              }}
            >
              {/*
                Pass tourIds as props to Main/Chat so it can apply them
                to header, video-call, voice-call, message-input, emoji, attachment, send-btn
              */}
              <Main tourIds={{
                chatHeader: "chat-tour-chat-header",
                videoCall: "chat-tour-video-call",
                voiceCall: "chat-tour-voice-call",
                messageInput: "chat-tour-message-input",
                emoji: "chat-tour-emoji",
                attachment: "chat-tour-attachment",
                sendBtn: "chat-tour-send-btn",
              }} />
            </Box>
          </Box>

          {/* ── 🤖 Chat Feature Bot ── */}
           <ChatFeatureBot
             show={chatBotEnabled}
             autoStart={chatBotAutoStart}
             onAutoStart={() => {
               recordBotGuideAutoOpen(BOT_TYPES.CHAT);
               setChatBotAutoStart(false);
             }}
           />

        </QueryClientProvider>
      </ChatContextProvider>
    </SideNavBar>
  );
};

export default ChatBoxPage;
